/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export enum ProactiveChatNames {
    CartAmount = 'Cart Total Amount',
    DateRange = 'Date Range',
    FromSpecificPage = 'From Specific Page',
    NumberOfItems = 'Cart Number of Items',
    PageVisits = 'Page Visits',
    SpecificMarket = 'Specific Market',
    SpecificPage = 'Specific Page',
    SpecificProduct = 'Specific Product',
    WaitOnTime = 'Wait on Time'
}
